module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "block_8",
    attrs: {
      "id": "calibre_pb_3"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "block_9"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_9"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_9"
  }), _vm._v(" "), _c('h1', {
    staticClass: "block_1",
    attrs: {
      "id": "id_Toc168649515"
    }
  }, [_vm._v("Glossary of RomanPlace Names"), _c('br', {}), _vm._v("for"), _c('br', {}), _vm._v("‘The Secret Sign’")]), _vm._v(" "), _c('p', {
    staticClass: "block_9"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_9"
  }), _vm._v(" "), _c('table', {
    staticClass: "table_"
  }, [_c('tbody', {
    staticClass: "calibre5"
  }, [_c('tr', {
    staticClass: "calibre6"
  }, [_c('td', {
    staticClass: "td_"
  }, [_c('p', {
    staticClass: "block_10"
  }, [_vm._v("Britannia")])]), _vm._v(" "), _c('td', {
    staticClass: "td_1"
  }, [_c('p', {
    staticClass: "block_10"
  }, [_vm._v("Britain")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre6"
  }, [_c('td', {
    staticClass: "td_2"
  }, [_c('p', {
    staticClass: "block_10"
  }, [_vm._v("Camulodunum")])]), _vm._v(" "), _c('td', {
    staticClass: "td_3"
  }, [_c('p', {
    staticClass: "block_10"
  }, [_vm._v("Colchester")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre6"
  }, [_c('td', {
    staticClass: "td_2"
  }, [_c('p', {
    staticClass: "block_10"
  }, [_vm._v("Dubris")])]), _vm._v(" "), _c('td', {
    staticClass: "td_3"
  }, [_c('p', {
    staticClass: "block_10"
  }, [_vm._v("Dover")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre6"
  }, [_c('td', {
    staticClass: "td_2"
  }, [_c('p', {
    staticClass: "block_10"
  }, [_vm._v("Gallia")])]), _vm._v(" "), _c('td', {
    staticClass: "td_3"
  }, [_c('p', {
    staticClass: "block_10"
  }, [_vm._v("France (Gaul)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre6"
  }, [_c('td', {
    staticClass: "td_2"
  }, [_c('p', {
    staticClass: "block_10"
  }, [_vm._v("Hispania")])]), _vm._v(" "), _c('td', {
    staticClass: "td_3"
  }, [_c('p', {
    staticClass: "block_10"
  }, [_vm._v("Spain")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre6"
  }, [_c('td', {
    staticClass: "td_2"
  }, [_c('p', {
    staticClass: "block_10"
  }, [_vm._v("Londinium")])]), _vm._v(" "), _c('td', {
    staticClass: "td_3"
  }, [_c('p', {
    staticClass: "block_10"
  }, [_vm._v("London")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre6"
  }, [_c('td', {
    staticClass: "td_2"
  }, [_c('p', {
    staticClass: "block_10"
  }, [_vm._v("Melita")])]), _vm._v(" "), _c('td', {
    staticClass: "td_3"
  }, [_c('p', {
    staticClass: "block_10"
  }, [_vm._v("Malta")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre6"
  }, [_c('td', {
    staticClass: "td_2"
  }, [_c('p', {
    staticClass: "block_10"
  }, [_vm._v("Tamesis")])]), _vm._v(" "), _c('td', {
    staticClass: "td_3"
  }, [_c('p', {
    staticClass: "block_10"
  }, [_vm._v("River Thames")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre6"
  }, [_c('td', {
    staticClass: "td_2"
  }, [_c('p', {
    staticClass: "block_10"
  }, [_vm._v("Tiberus")])]), _vm._v(" "), _c('td', {
    staticClass: "td_3"
  }, [_c('p', {
    staticClass: "block_10"
  }, [_vm._v("River Tiber")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre6"
  }, [_c('td', {
    staticClass: "td_2"
  }, [_c('p', {
    staticClass: "block_10"
  }, [_vm._v("Verulamium")])]), _vm._v(" "), _c('td', {
    staticClass: "td_3"
  }, [_c('p', {
    staticClass: "block_10"
  }, [_vm._v("St. Albans")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre6"
  }, [_c('td', {
    staticClass: "td_4"
  }, [_c('p', {
    staticClass: "block_10"
  }, [_vm._v("Watling Street")])]), _vm._v(" "), _c('td', {
    staticClass: "td_5"
  }, [_c('p', {
    staticClass: "block_10"
  }, [_vm._v("Mainly A2")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "block_11"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }, [_c('b', {
    staticClass: "calibre7"
  }, [_vm._v("“ICTHUS ")]), _vm._v("= FISH in ancient Greek, the initial letters of which stand for "), _c('b', {
    staticClass: "calibre7"
  }, [_vm._v("I")]), _vm._v("sous "), _c('b', {
    staticClass: "calibre7"
  }, [_vm._v("C")]), _vm._v("hristos "), _c('b', {
    staticClass: "calibre7"
  }, [_vm._v("TH")]), _vm._v("eou (God’s) "), _c('b', {
    staticClass: "calibre7"
  }, [_vm._v("U")]), _vm._v("ios (Son) "), _c('b', {
    staticClass: "calibre7"
  }, [_vm._v("S")]), _vm._v("oteros (Saviour).”"), _c('br', {
    staticClass: "calibre4",
    attrs: {
      "id": "calibre_pb_4"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f632f26a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_003.vue
// module id = 72
// module chunks = 0